export const TrLocale = {
    page: {
        txtTitle: 'UNVOX | Vokalleri anında kaldır',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox logosu',
        },
        action: {
            txtBack: 'Geri',
            txtRetry: 'Tekrar dene',
            txtStartOver: 'Baştan başla',
        },
        job: {
            txtCheckingStatus: 'İş durumu kontrol ediliyor',
            txtIdLabel: 'İş Kimliği',
        },
        footer: {
            linkPrivacyPolicy: 'Gizlilik Politikası',
            linkTerms: 'Şartlar',
            linkRefunds: 'İadeler',
            linkSupport: 'Destek',
            txtAllRightsReserved: 'Tüm hakları saklıdır.',
            txtBugReportsAndFeatures: 'Hata raporları ve özellik istekleri',
        },
        share: {
            title: 'UNVOX | Şarkı vokallerini tek tıkla kaldır',
            text: 'Favori şarkılarınızı kolayca karaokeye hazır enstrümantallere dönüştürün!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Tek tıkla vokal kaldırma',
            txtHeroSubtitle: 'Parçanızdan veya doğrudan YouTube\'dan anında enstrümantal',
            txtInputTypeLabel: 'Giriş türü',
            txtInputTypeFile: 'Ses dosyası yükle',
            txtInputTypeYoutube: 'YouTube bağlantısı',
            txtInputFilePick: 'Dosya seç',
            txtInputFileSub: 'Yaygın ses formatları ({{formats}}), en fazla {{size}} MB.',
            txtPreviewAction: 'Vokalleri kaldır',
            txtPreviewFailed: 'Bilinmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
            txtUploadSelectFile: 'Henüz dosya seçilmedi',
            txtYoutubeLabel: 'YouTube URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Herkese açık bir YouTube bağlantısı yapıştırın.',
            txtYoutubeMissing: 'Lütfen bir YouTube URL\'si yapıştırın.',
            txtYoutubeInvalid: 'Geçerli bir YouTube URL\'si girin.',
            txtYoutubeTooLong: 'Bu video 15 dakikadan uzun. Lütfen daha kısa bir video seçin.',
            txtCheckoutUploadFailed: 'Yükleme başarısız oldu. Lütfen tekrar deneyin.',
            txtUploadMissing: 'Yüklemeden önce lütfen bir dosya seçin.',
            txtFileTypeInvalid: 'Desteklenmeyen dosya türü. Lütfen bir ses dosyası yükleyin (ör. {{formats}}).',
            txtFileTooLarge: 'Dosya çok büyük. Maksimum boyut {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Önizleme oluşturulamadı',
            txtUnavailableBody: 'Bilinmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
            txtPreparingTitle: 'Önizleme hazırlanıyor',
            txtPreparingBody: 'Bu işlem 2 dakikaya kadar sürebilir',
        },
        payment: {
            txtUnavailableTitle: 'Önizleme oluşturulamadı',
            txtUnavailableBody: 'Bilinmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
            txtPreparingTitle: 'Önizleme hazırlanıyor',
            txtCheckoutCancelledBody: 'Herhangi bir ücret alınmadı. İstediğiniz zaman tekrar deneyebilirsiniz.',
            txtTrackPreviewLabel: 'Parça önizlemesi',
            txtTrackPreviewHelper: 'Bu önizleme, değerlendirmeniz için parçanızın 15 saniyelik bölümüdür',
            txtEmailLabel: 'E-posta adresi',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'İndirme bağlantınızı göndermek için bunu kullanacağız.',
            txtCheckoutAction: 'Sadece {{price}} karşılığında vokalleri kaldır',
            txtCheckoutActionFallback: 'Vokalleri kaldır',
            txtCheckoutFailed: 'Ödeme başlatılamadı. Lütfen tekrar deneyin.',
            txtInvalidEmail: 'Geçerli bir e-posta adresi girin.',
        },
        processing: {
            txtMissingTitle: 'İş kimliği eksik',
            txtMissingBody: 'Bu sayfa için bir iş kimliği gerekiyor. Lütfen yeni bir önizleme başlatın.',
            txtMissingAction: 'Yüklemeye dön',
            txtStatusFailed: 'İş durumu alınamadı. Lütfen tekrar deneyin.',
            txtErrorTitle: 'Bir şeyler ters gitti',
            txtSupportAction: 'Destek ile iletişime geç',
            txtConfirmingTitle: 'Ödeme onaylanıyor',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Güncellemeler kontrol ediliyor',
            txtWorkingTitle: 'Tam parçanız işleniyor',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Yeni bir tane başlat',
            txtReadyTitle: 'İndirme hazır',
            txtReadyBody: 'Enstrümantal dosyanız indirilmeye hazır.',
            txtDownloadAction: 'İndir',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Yeni bir tane başlat',
        },
        invalidJob: {
            txtTitle: 'Geçersiz iş kimliği',
            txtBody: 'Bu iş bulunamadı. Lütfen yeni bir yükleme başlatın.',
            txtAction: 'Baştan başla',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Destek',
            txtTitle: 'Destek ile iletişime geç',
            txtLastUpdatedLabel: 'Son güncelleme',
            txtLastUpdatedDate: '9 Şubat 2026',
            txtSectionEmailTitle: 'E-posta',
            txtSectionEmailBodyPrefix: 'Bize e-posta gönderin',
            txtSectionIncludeJobIdTitle: 'İş kimliğinizi ekleyin',
            txtSectionIncludeJobIdBody: 'İşinizi hızlıca bulabilmemiz için lütfen iş kimliğinizi ekleyin. Ödeme yaptıysanız, ödeme sırasında kullanılan e-postayı da ekleyin.',
            txtSectionBugReportsTitle: 'Hata raporları',
            txtSectionBugReportsBody: 'Alt bilgideki bağlantı üzerinden hata raporları ve özellik istekleri de gönderebilirsiniz.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Geri bildirim',
            txtTitle: 'Hata raporları ve özellik istekleri',
            txtSubtitle: 'UNVOX henüz erken aşamada. Bir şey ters görünüyorsa veya bir fikriniz varsa gönderin. Açık raporlar düzeltmeleri yayınlamanın en hızlı yoludur.',
            txtWhatToIncludeTitle: 'Neler eklenmeli',
            txtChecklistExpectedVsActual: 'Beklediğiniz şey ve gerçekleşen şey',
            txtChecklistSteps: 'Yeniden üretme adımları (1, 2, 3)',
            txtChecklistBrowserOs: 'Tarayıcınız ve işletim sisteminiz',
            txtChecklistJobId: 'İş kimliği (yükleme içeriyorsa)',
            txtTipTitle: 'İpucu',
            txtTipBody: 'Bize e-posta gönderiyorsanız, teslimat e-postasına doğrudan yanıt verip şablonu yapıştırabilirsiniz.',
            txtTemplateTitle: 'Kopyala-yapıştır şablonu',
            txtTemplateBody: 'Hata raporu / Özellik isteği\n\nTür: bug | feature\nÖzet:\n\nDetaylar:\n- Ne oldu:\n- Ne bekliyordunuz:\n- Yeniden üretme adımları:\n  1.\n- Tarayıcı/OS:\n\nİsteğe bağlı:\n- İş Kimliği:\n- YouTube URL:\n- Ekran görüntüsü/video:\n',
            txtTemplatePageLabel: 'Sayfa',
            txtTemplateUserAgentLabel: 'User agent',
            txtCopyActionIdle: 'Şablonu kopyala',
            txtCopyActionCopied: 'Kopyalandı',
            txtCopyActionFailed: 'Kopyalama başarısız',
            txtCopyHelpFailed: 'Panoya erişim engellendi. Yine de yukarıdaki metni seçip manuel olarak kopyalayabilirsiniz.',
            txtCopyHelpIdle: 'Buradaki hiçbir şey otomatik olarak gönderilmez. Bu sayfa yalnızca iyi bir rapor hazırlamanıza yardımcı olur.',
        },
    },
};
